import React from 'react'

import { SiteDataContext } from '../../../components/page-wrapper'
import { ButtonNew, Category, IconNew, RichText, SectionHeader } from '../../../storybook'
import { filterTypes } from '../../../storybook/Filter'
import { getMicroCopy } from '../../../utils/microcopy'
//
import { useMicroCopyData } from '@/src/context/MicroCopyContext'

const BodySection = ({ integration, slugPrefix, requestDemoSlug }) => {
  if (!integration) {
    return null
  }

  const siteData = React.useContext(SiteDataContext)
  const { settings, lang } = siteData
  const microCopyData = useMicroCopyData()

  const { pages } = settings
  const { integrationsOverview } = pages
  const integrationsSlug = integrationsOverview?.slug || 'integrations'

  const sidebar = (
    <Category
      filters={[
        {
          id: 'integration-filter-category',
          type: filterTypes.tags,
          title: getMicroCopy({ key: 'category', data: microCopyData[lang] }),
          showMoreLabel: getMicroCopy({ key: 'showMore', data: microCopyData[lang] }),
          showLessLabel: getMicroCopy({ key: 'showLess', data: microCopyData[lang] }),
          items: integration?.categories?.map((cat) => ({
            id: cat?.sys?.id || cat?.id || null,
            label: cat?.title || null,
            url: `/${slugPrefix}/${integrationsSlug}/${cat?.slug}`.replace('//', '/')
          }))
        },
        {
          id: 'integration-filter-countries',
          type: filterTypes.countries,
          title: getMicroCopy({ key: 'supportedIn', data: microCopyData[lang] }),
          showMoreLabel: getMicroCopy({ key: 'showMore', data: microCopyData[lang] }),
          showLessLabel: getMicroCopy({ key: 'showLess', data: microCopyData[lang] }),
          items: integration?.markets
            .map((market) => ({
              id: `market-${market?.id || market?.countryIsoCode}`,
              label: getMicroCopy({
                key: `market.${market?.countryIsoCode.toLocaleLowerCase()}`,
                data: microCopyData[lang]
              }),
              img: market.svgFlagRound || market.svgFlag,
              url: `/${slugPrefix}/${integrationsSlug}#${market?.countryIsoCode}`.replace(
                /\/\//g,
                '/'
              ),
              code: market?.countryIsoCode
            }))
            .sort((a, b) => (a.label > b.label || a.code === 'XX' ? 1 : b.label > a.label ? -1 : 0))
        }
      ]}
      summary={{
        title: getMicroCopy({ key: 'additionalInfo', data: microCopyData[lang] }),
        headingType: 'h5',
        inverted: true
      }}
    >
      <div className="c-category__actions">
        <ButtonNew text="button" url={requestDemoSlug} variant={'green'} fullWidth>
          {getMicroCopy({ key: 'requestDemo', data: microCopyData[lang] })}
          <IconNew name="tabler-arrow-narrow-right" />
        </ButtonNew>

        {integration.website ? (
          <ButtonNew text="button" url={integration?.website} variant={'secondary'} fullWidth>
            {getMicroCopy({ key: 'website', data: microCopyData[lang] })}
            <IconNew name="tabler-arrow-narrow-right" />
          </ButtonNew>
        ) : null}
      </div>
    </Category>
  )

  return (
    <section className="c-body-section l-section l-section-small l-section--white l-section--no-padding-bottom@to:viewport-9">
      <div className="l-container:12/12 l-container--default-spacing u-display:none@to:viewport-9">
        <div className="l-grid l-grid--default-spacing">
          <div className="l-grid__col:6/12@at:viewport-9">
            <SectionHeader
              headingTyp={'h2'}
              title={getMicroCopy({
                key: 'bodyTitle',
                data: microCopyData[lang],
                tokens: { integration: integration.title || '{integration}' }
              })}
              eyebrow={getMicroCopy({
                key: 'bodyPreface',
                data: microCopyData[lang],
                tokens: { integration: integration.title || '{integration}' }
              })}
            />
            <RichText content={integration?.body} />
          </div>
          <div className="l-grid__col:6/12@at:viewport-9 l-grid__col:6/12@at:viewport-12">
            {sidebar}
          </div>
        </div>
      </div>

      <div className="u-display:none@at:viewport-9">
        <div className="l-container:12/12 l-container--default-spacing">
          <SectionHeader
            headingTyp={'h2'}
            title={getMicroCopy({
              key: 'bodyTitle',
              data: microCopyData[lang],
              tokens: { integration: integration.title || '{integration}' }
            })}
            eyebrow={getMicroCopy({
              key: 'bodyPreface',
              data: microCopyData[lang],
              tokens: { integration: integration.title || '{integration}' }
            })}
          />
          <RichText content={integration?.body} />
        </div>

        <div className="u-margin-top:64">{sidebar}</div>
      </div>
    </section>
  )
}

export default BodySection
